import { useState, useEffect, useRef } from "react";
import Image from "next/image";
export const showcaseData = [
  {
    id: 1,
    navText: "Persona",
  },
  {
    id: 2,
    navText: "Knowledge",
  },
  {
    id: 3,
    navText: "ActionBooks",
  },
  {
    id: 4,
    navText: "Boundaries",
    // videoURL:
    //   "https://sendbird.imgix.net/cms/Omni_4_Unified_Final_2025-02-02-050323_czsl_2025-02-05-103241_tpqv.mp4",
    // icon: "https://sendbird.imgix.net/cms/Anywhere-logo.svg",
    // heading: "Unify all channels",
    // desc: "From email to chat to voice, manage everything in one AI-powered dashboard.",
    // buttonText: "Discover now",
    // buttonClickURL: "/clm/",
    // videoLength: 11,
  },
];

function ShowCase({
  scrollToCard,
  activeIndex,
  setActiveIndex,
  categories,
  isDarkMode,
}) {
  const handleClick = (idx) => {
    setActiveIndex(idx);
    scrollToCard?.(idx); // Call scroll function
  };

  return (
    <>
      <div className="md:flex-row md:flex hidden flex-col justify-center items-center w-full gap-6">
        {/* Navigation */}
        <div className="flex-1 md:w-auto w-full">
          <div className="flex flex-col ">
            {categories?.map((item, idx) => {
              const isActive = activeIndex === idx;

              return (
                <button
                  key={item.id}
                  className={`relative h-[46px] bg-transparent ${
                    isActive ? "" : "border-t"
                  } ${
                    isDarkMode ? "text-gray-300" : "text-gray-600"
                  }  flex justify-start items-center gap-2 hover:bg-black/ ${
                    isActive ? "border-gray-900 font-bold" : "border-gray-300"
                  }`}
                  onClick={() => handleClick(idx)}
                >
                  <span
                    className={`rounded-full border font-medium ${
                      isDarkMode ? "border-white" : "border-black"
                    }  flex justify-center items-center w-7 h-7  ${
                      isActive
                        ? `${
                            isDarkMode
                              ? "bg-white text-black"
                              : "bg-black text-white"
                          }`
                        : `${
                            isDarkMode
                              ? "text-gray-300"
                              : "text-black bg-transparents"
                          }`
                    }`}
                  >
                    {idx + 1}
                  </span>
                  <span className="relative z-10 text-lg whitespace-nowrap">
                    {item}
                  </span>
                  <span
                    // background: linear-gradient(275deg, #c86aff -8.37%, #3164ff)
                    // want to use linear -gradient as bg color
                    className="absolute top-0 left-0 h-[3px] bg-gradient-to-r from-[#c86aff] to-[#3164ff] transition-all ease-linear duration-300"
                    style={{
                      width: isActive ? "100%" : "0%",
                    }}
                  />
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export function ShowCaseCard({
  title,
  desc,
  imgSrc,
  titleSize = "4xl",
  descSize = "xl",
  gap = 0,
  mb = 0,
  idx = 0,
  cat,
}) {
  return (
    <div className="flex flex-col gap-4 md:gap-8 pb-12 md:pb-32">
      <div
        className={`flex flex-col md:flex-row gap-3 md:gap-8 mb-8 ${
          cat ? "border-t border-gray-300 pt-4" : ""
        } md:border-0 md:pt-0`}
      >
        {cat && (
          <div className="flex gap-2 md:hidden ">
            <span
              // isActive ? "bg-black text-white" : "text-black bg-transparents"
              className={`rounded-full border border-black flex justify-center items-center w-7 h-7 font-light bg-black text-white inline`}
            >
              {idx + 1}
            </span>
            <span className="relative z-10 text-lg inline font-medium">
              {cat}
            </span>
          </div>
        )}
        <h2 className={`flex-1 text-2xl md:text-${titleSize} font-semibold`}>
          {title}
        </h2>
        <p className={`flex-1 text-${descSize} `}>{desc}</p>
      </div>
      <Image
        src={imgSrc}
        alt="ai-agent-builder"
        width={1280}
        height={490}
        className="w-full object-cover h-full rounded-xl md:rounded-[30px]"
      />
      {/* <Image
        src={imgSrc}
        alt="ai-agent-builder"
        width={666}
        height={500}
        className="w-full object-cover h-full rounded-2xl border md:border-0 block md:hidden"
      /> */}
    </div>
  );
}

export const BuilderShowCaseSection = ({
  heading = "",
  categories = [],
  showcaseData = [],
  isDarkMode = false,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const cardRefs = useRef([]);
  const scrollingRef = useRef(false);

  // const scrollToCard = (index) => {
  //   cardRefs.current[index]?.scrollIntoView({ behavior: "smooth" });
  //   setActiveIndex(index);
  // };

  // Scroll to card when activeIndex changes
  const scrollToCard = (index) => {
    scrollingRef.current = true;
    cardRefs.current[index]?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });

    // Reset scrolling flag after animation completes
    setTimeout(() => {
      scrollingRef.current = false;
    }, 1000);
  };

  // Set up Intersection Observer to detect which card is in view
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: "0px 0px -50% 0px", // Trigger when card enters top half of viewport
      threshold: 0.1,
    };

    const observerCallback = (entries) => {
      // Ignore during programmatic scrolling
      if (scrollingRef.current) return;

      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = cardRefs.current.findIndex(
            (ref) => ref === entry.target
          );
          if (index !== -1) {
            setActiveIndex(index);
          }
        }
      });
    };

    const observer = new IntersectionObserver(
      observerCallback,
      observerOptions
    );

    // Observe all cards
    cardRefs.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section className="">
      <div
        className={`max-w-screen-xl md:px-8 px-6 mx-auto py-10 ${
          isDarkMode ? "text-white" : "text-gray-900"
        }`}
      >
        <h2 className="text-4xl md:text-5xl font-semibold mb-16 md:mb-24 md:pl-72">
          {heading}
        </h2>
        <div className="flex">
          <div className="flex-2 w-[24%] pr-12 hidden md:block">
            <div className="w-full sticky top-[113px]">
              <ShowCase
                scrollToCard={scrollToCard}
                activeIndex={activeIndex}
                setActiveIndex={setActiveIndex}
                categories={categories}
                isDarkMode={isDarkMode}
              />
            </div>
          </div>
          <div className="flex-1 ">
            {showcaseData.map((data, idx) => (
              <div
                key={idx}
                ref={(el) => (cardRefs.current[idx] = el)}
                className="scroll-mt-[130px]"
              >
                <ShowCaseCard
                  title={data.heading}
                  desc={data.subHeading}
                  imgSrc={data.imgSrc}
                  idx={idx}
                  cat={categories?.[idx]}
                />
              </div>
            ))}
          </div>
          {/* <div className="flex-1 ">
            <div
              ref={(el) => (cardRefs.current[0] = el)}
              className="scroll-mt-[130px]"
            >
              <ShowCaseCard
                title={showcaseData[0]?.heading}
                desc={showcaseData[0]?.subHeading}
                imgSrc={showcaseData[0]?.imgSrc}
                idx={0}
                cat={categories?.[0]}
              />
            </div>
            <div
              ref={(el) => (cardRefs.current[1] = el)}
              className="scroll-mt-[130px]"
            >
              <ShowCaseCard
                title={showcaseData[1]?.heading}
                desc={showcaseData[1]?.subHeading}
                imgSrc={showcaseData[1]?.imgSrc}
                idx={1}
                cat={categories?.[1]}
              />
            </div>
            <div
              ref={(el) => (cardRefs.current[2] = el)}
              className="scroll-mt-[130px]"
            >
              <ShowCaseCard
                title={showcaseData[2]?.heading}
                desc={showcaseData[2]?.subHeading}
                imgSrc={showcaseData[2]?.imgSrc}
                idx={2}
                cat={categories?.[2]}
              />
            </div>
            <div
              ref={(el) => (cardRefs.current[3] = el)}
              className="scroll-mt-[130px]"
            >
              <ShowCaseCard
                title={showcaseData[3]?.heading}
                desc={showcaseData[3]?.subHeading}
                imgSrc={showcaseData[3]?.imgSrc}
                idx={3}
                cat={categories?.[3]}
              />
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};
